import { Divider } from "@mui/material";
import React from "react";

const items = [
  { title: "Select Customer" },
  { title: "Edit Customer" },
  { title: "New Customer" },
  { title: "No Customer" },
  { title: "Account Details" },
];

const RightMenu = () => {
  return (
    <div
      style={{
        background: "#FFF",
        width: 236,
        height: 388,
      }}
    >
      {items.map((item, index) => (
        <>
          <div
            style={{
              margin: "10px 0",
              fontSize: 18,
              color: "#000",
              fontWeight: "400",
              fontFamily: `Poppins, sans-serif`,
            }}
          >
            {item.title}
          </div>
          <Divider style={{ background: "#EFF3F4", height: 2 }} />
        </>
      ))}
    </div>
  );
};

export default RightMenu;
